import { render, staticRenderFns } from "./level-2-2-1.vue?vue&type=template&id=69ceb124&"
import script from "./level-2-2-1.vue?vue&type=script&lang=js&"
export * from "./level-2-2-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports